import supportedTimezones from "../constants/SupportedTimezones";
import { DateTime } from "luxon";

export const getNowDateTime = (
  zone: string = supportedTimezones.EuropeLondon
) => DateTime.local().setZone(zone);

export const getNowDate = (zone: string = supportedTimezones.EuropeLondon) =>
  DateTime.local().setZone(zone).toJSDate();
